module.exports = __webpack_public_path__ + "static/media/clock-outlined.d8ed0d0a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/clock-outlined.svg
// module id = 2247
// module chunks = 0